module.exports = __webpack_public_path__ + "static/media/logo_light.e4173260.svg";